var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app-top-div"},[(!_vm.isOnline)?_c('div',{staticClass:"network-connectivity-box"},[_c('div',{staticClass:"network-connectivity-wrapper"},[_c('div',{staticClass:"network-connectivity-container"},[_c('div',{staticClass:"network-connectivity-body"},[_vm._t("body",[_c('h2',[_vm._v(_vm._s(_vm.$t('errorNetStr')))]),_vm._v(" "),_c('h3',[_vm._v("接続された状態でご利用ください")])])],2)])])]):_vm._e(),_vm._v(" "),_c('router-view')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-41e423f2","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 763
// module chunks = 1